import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import IconComponent from '../../icon/icon';
import { HeaderMenuViewModel } from './HeaderMenu.vm';
import { MenuContainer, MenuItem, MenuWrapper, SubmenuItem, SubmenuWrapper } from './styles';

export type Item = {
  label: string;
  icon: string;
  page: string;
  selected?: boolean;
  hasSubmenu?: boolean;
};

const HeaderMenu: React.FC = () => {
  const vm = useViewModel(HeaderMenuViewModel);

  const navigate = useNavigate();
  const location = useLocation();

  const isCurrentPage = (page: string[]) => page.includes(location.pathname);

  const openAdmin = () => {
    window.location.href = `/admin`;
  };

  const openLibrary = () => {
    navigate('/library');
  };

  const openStudyPlan = () => {
    navigate('/');
  };

  const openPractice = () => {
    navigate('/practice');
  };

  const openEssay = () => {
    navigate('/essays');
  };

  return (
    <MenuWrapper>
      <MenuContainer>
        {!vm.shouldShowPaywall && (
          <>
            {vm.shouldShowStudyPlanTab && (
              <MenuItem onClick={openStudyPlan} selected={isCurrentPage(['/'])}>
                <span>Minha Jornada</span>
              </MenuItem>
            )}
            <MenuItem onClick={openLibrary} selected={isCurrentPage(['/library'])}>
              <span>Cursos</span>
            </MenuItem>
            {vm.shouldShowPracticeTab && (
              <MenuItem hasSubmenu selected={isCurrentPage(['/practice', '/essay'])}>
                <span>
                  Treinar <IconComponent name="minimalisticArrow" />
                </span>
                <SubmenuWrapper>
                  {vm.shouldShowExerciseTab && (
                    <SubmenuItem onClick={openPractice}>Simulados</SubmenuItem>
                  )}
                  {vm.shouldShowEssayMenu && <SubmenuItem onClick={openEssay}>Redação</SubmenuItem>}
                </SubmenuWrapper>
              </MenuItem>
            )}
          </>
        )}

        {vm.user?.permissions.canViewAdmin && (
          <MenuItem onClick={openAdmin}>
            <span>Administração</span>
          </MenuItem>
        )}
      </MenuContainer>
    </MenuWrapper>
  );
};

export default observer(HeaderMenu);
